import { Directive, Input, HostListener, ElementRef } from '@angular/core';
import jump from 'jump.js';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[href]',
  standalone: false
})
export class HrefDirective {
  @Input() link: string;
  @HostListener('click', ['$event']) onClick(event): void {
    if (!!this.link && this.isFragment(this.link)) {
      event.preventDefault();
      const htmlElement: HTMLElement = this._el.nativeElement.getRootNode().querySelector(this.link);
      if (htmlElement) {
        jump(this.link, {
          offset: -200,
          a11y: true
        });
      }
    }
  }
  constructor(private readonly _el: ElementRef) {}
  isFragment(link: string): boolean {
    const reg = new RegExp(/^#\w+/);
    return reg.test(link);
  }
}
